import { GridItemNormalizer } from '../types';

export default class CostObjectNormalizer implements GridItemNormalizer {
  support(value: any): boolean {
    return value?.__typename === 'object_Cost';
  }

  normalize(value: any) {
    return value?.cost_ctr;
  }

  normalizeAsSelectValue(value: any) {
    return this.normalize(value);
  }

  getRequiredFields() {
    return {
      id: '',
      cost_ctr: '',
    };
  }
}
